// need to change the space between the title and the text. can't do it with CSS
// need to add hover state to cancel button. it should be #FAFAFA
// need to change the space between the CTAs and the text

import { Flex } from '@mantine/core';
import StyledButton, { StyledButtonProps } from '@/components/StyledButton/StyledButton.tsx';

type props = {
  onClose: () => void;
  onConfirm: () => void;
  onCancel?: () => void;
  confirmText?: string;
  cancelText?: string;
  cancelButtonProps?: StyledButtonProps;
  confirmButtonProps?: StyledButtonProps;
  confirmType?: 'primary' | 'delete';
  confirmDisabled?: boolean;
  confirmLoading?: boolean;
  closeOnConfirm?: boolean;
  showCancel?: boolean;
};

const ModalConfirmationButtons = ({
  onClose,
  onConfirm,
  onCancel,
  confirmText = 'Yes',
  cancelText = 'Cancel',
  cancelButtonProps,
  confirmButtonProps,
  confirmType = 'primary',
  confirmDisabled = false,
  confirmLoading = false,
  closeOnConfirm = true,
  showCancel = true,
}: props) => {
  return (
    <Flex mt="sm" justify="flex-end" gap={'xs'}>
      {showCancel && (
        <StyledButton
          variant={'outline'}
          size={'md'}
          onClick={() => {
            onCancel?.();
            onClose();
          }}
          {...cancelButtonProps}
        >
          {cancelText}
        </StyledButton>
      )}
      <StyledButton
        onClick={() => {
          onConfirm();
          if (closeOnConfirm) {
            onClose();
          }
        }}
        variant={confirmType === 'primary' ? 'primary' : 'delete'}
        disabled={confirmDisabled}
        // data-disabled={true}
        // data-disabled={true}
        loading={confirmLoading}
        loaderProps={{ color: 'white' }}
        {...confirmButtonProps}
      >
        {confirmText}
      </StyledButton>
    </Flex>
  );
};

export default ModalConfirmationButtons;
